<div class="dash-shell">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <a class="page-head__crumb" routerLink="/ops/dashboard">Ops</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <span class="page-head__crumb page-head__crumb--current" aria-current="page">Debtors</span>
    </nav>
    <div class="page-head__bar">
      <div class="page-head__titles">
        <h1 class="page-head__title">Debtor review</h1>
        <p class="page-head__subtitle">Debtors Finance</p>
      </div>
    </div>
  </header>

  <div class="sg-empty sg-empty--bordered dq-placeholder">
    <app-icon name="briefcase" [size]="40" />
    <p class="sg-empty__title">Debtor review queue</p>
    <p class="sg-empty__desc">
      Opens from a facility's debtor book for now. Navigate to a facility to review its debtors.
    </p>
    <a class="dq-link" routerLink="/ops/df/facilities">
      <app-icon name="arrow-right" [size]="16" />
      Go to DF Facilities
    </a>
  </div>
</div>
